import { AdminCommercialPerformance } from "./AdminCommercialPerformance"
import { AdminSubscriptionCase } from "./AdminSubscriptionCase"
import { AdminChartPoint } from "./AdminChartPoint"
import { AdminRevenue } from "./AdminRevenue"
import { AdminPlatformUsage } from "./AdminPlatformUsage"
import { AdminOverview } from "./AdminOverview"

export class AdminDashboard {
  overview: AdminOverview

  revenue: AdminRevenue

  platformUsage: AdminPlatformUsage

  monthlyRevenueSeries: AdminChartPoint[]

  dailyOrdersSeries: AdminChartPoint[]

  monthlyCompanyGrowthSeries: AdminChartPoint[]

  subscriptionCases: AdminSubscriptionCase[]

  commercialPerformance: AdminCommercialPerformance

  constructor(data: Partial<AdminDashboard> = {}) {
    this.overview = new AdminOverview(data.overview)

    this.revenue = new AdminRevenue(data.revenue)

    this.platformUsage = new AdminPlatformUsage(data.platformUsage)

    this.monthlyRevenueSeries = data.monthlyRevenueSeries ?? []

    this.dailyOrdersSeries = data.dailyOrdersSeries ?? []

    this.monthlyCompanyGrowthSeries = data.monthlyCompanyGrowthSeries ?? []

    this.subscriptionCases = data.subscriptionCases?.map((e) => new AdminSubscriptionCase(e)) ?? []

    this.commercialPerformance = new AdminCommercialPerformance(data.commercialPerformance)
  }
}
